import React, { useState } from 'react';
import { Button } from '@mui/material';

const HostelAttendance = () => {
  const [selectedFloor, setSelectedFloor] = useState('');
  const [selectedRoom, setSelectedRoom] = useState('');
  const [studentsList, setStudentsList] = useState([]);
  const [attendance, setAttendance] = useState({}); 
  const studentsData = {
    room1: ['Student A', 'Student B', 'Student C'],
    room2: ['Student D', 'Student E', 'Student F'],
    room3: ['Student G', 'Student H', 'Student I'],
    room4: ['Student J', 'Student K', 'Student L'],
  };

  const handleFloorChange = (event) => {
    setSelectedFloor(event.target.value);
    setSelectedRoom('');
    setStudentsList([]);
  };

  const handleRoomChange = (event) => {
    const selectedRoom = event.target.value;
    setSelectedRoom(selectedRoom);
    setStudentsList(studentsData[selectedRoom] || []); 
  };

  const handleAttendance = (student, period, status) => {
    const updatedAttendance = { ...attendance };
    if (!updatedAttendance[student]) {
      updatedAttendance[student] = {};
    }
    updatedAttendance[student][period] = status;
    setAttendance(updatedAttendance);
  };

  const handleSubmit = () => {
    
    console.log('Attendance Data:', attendance);
   
  };

  return (
    <div className="container-fluid mt-4">
      <h5 className="my-4">Hostel Attendance</h5>
      <div className="row my-4">
        <div className="col-md-6">
          <label htmlFor="floor">Select Floor: </label>
          <select
            name="floor"
            className="common-input form-select"
            value={selectedFloor}
            onChange={handleFloorChange}
          >
            <option value="">Select Floor</option>
            <option value="floor1">Floor 1</option>
            <option value="floor2">Floor 2</option>
            <option value="floor3">Floor 3</option>
            <option value="floor4">Floor 4</option>
          </select>
        </div>
        <div className="col-md-6">
          <label htmlFor="room">Select Room: </label>
          <select
            name="room"
            className="common-input form-select"
            value={selectedRoom}
            onChange={handleRoomChange}
          >
            <option value="">Select Room</option>
            {selectedFloor === 'floor1' && (
              <>
                <option value="room1">Room 1</option>
                <option value="room2">Room 2</option>
              </>
            )}
            {selectedFloor === 'floor2' && (
              <>
                <option value="room3">Room 3</option>
                <option value="room4">Room 4</option>
              </>
            )}
            {selectedFloor === 'floor3' && (
              <>
                <option value="room5">Room 5</option>
                <option value="room6">Room 6</option>
              </>
            )}
            {selectedFloor === 'floor4' && (
              <>
                <option value="room7">Room 7</option>
                <option value="room8">Room 8</option>
              </>
            )}
          </select>
        </div>
      </div>

      {selectedRoom && (
        <div className="row">
          <div className="col">
            <h5>Students Attendance {selectedRoom}</h5>
            <div className="Table mb-6">
            <table className="table">
              <thead>
                <tr>
                  <th align='center'>Student Name</th>
                  <th>Morning Attendance</th>
                  <th>Evening Attendance</th>
                </tr>
              </thead>
              <tbody>
                {studentsList.map((student, index) => (
                  <tr key={index}>
                    <td>{student}</td>
                    <td>
                      <button
                        className={`btn btn-sm ${attendance[student]?.morning === 'present' ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => handleAttendance(student, 'morning', 'present')}
                      >
                        Present
                      </button>{' '}
                      <button
                        className={`btn btn-sm ${attendance[student]?.morning === 'absent' ? 'btn-danger' : 'btn-outline-danger'}`}
                        onClick={() => handleAttendance(student, 'morning', 'absent')}
                      >
                        Absent
                      </button>
                    </td>
                    <td>
                      <button
                        className={`btn btn-sm ${attendance[student]?.evening === 'present' ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => handleAttendance(student, 'evening', 'present')}
                      >
                        Present
                      </button>{' '}
                      <button
                        className={`btn btn-sm ${attendance[student]?.evening === 'absent' ? 'btn-danger' : 'btn-outline-danger'}`}
                        onClick={() => handleAttendance(student, 'evening', 'absent')}
                      >
                        Absent
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            
          </div>
        </div>
      )}

      {selectedRoom && (
        <div className="row mt-4">
          <div className="col-md-8">
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit Attendance
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HostelAttendance;
